// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__hnNsj","tab--active":"Tab_tab--active__QyTL4"};